import React from 'react';
import { Box, Breadcrumbs, Typography, Link } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Header from '../../components/Header';
import classes from './PO.module.scss';
import { EmptyState } from './components';

const POSection = () => {
  return (
    <Box className={classes.po}>
      <Breadcrumbs separator={<NavigateNextIcon />} className={classes.breadcrumb}>
        <Link color='inherit' href='/product/list'>
          Product List
        </Link>
        <Typography variant='body2'>PO</Typography>
      </Breadcrumbs>
      <Box display='flex' alignItems='center'>
        <Header title='PO' hiddenMore />
      </Box>
      <EmptyState />
    </Box>
  );
};
export default POSection;
